import { createContext, useContext } from 'react'

import { ReleasedLocale } from '../lib/locale'

type LocaleContextValue = {
  locale: string
  changeLocale: (next: ReleasedLocale) => void
}

export const LocaleContext = createContext<LocaleContextValue | null>(null)

export function useLocale(): LocaleContextValue {
  const ctx = useContext(LocaleContext)
  if (!ctx) {
    throw new Error('useLocale must be used within a LocaleContext provider')
  }
  return ctx
}
